import "./saga";
import moment from "moment";
import { getDepartments, getCurrentUser } from "@neumetric/blueprint-lib/store";
import { parseRemediationStatsData } from "./parser/remediation";
export * from "./slice";

const EXPORT_DATE_FORMAT = "YYMMDD";

const getDocState = (state) => state.document;
const getStatsState = (state) => state.central;

export const getDocStatusList = (state) => {
  const _state = getDocState(state);
  return _state?.docStatusList;
};

export const getDateRangeEnums = (state) => {
  const _state = getDocState(state);
  return _state?.dateRangeEnumns;
};

export const getActiveGuides = (state) => {
  const _state = getDocState(state);
  return _state?.activeGuides;
};

export const getDateInExportFormat = (iDate) => {
  return moment(iDate).format(EXPORT_DATE_FORMAT);
};

export const getRemediatorStats = (state) => {
  const _state = getStatsState(state);
  const remediatorStats = _state?.remediatorStats;
  if (remediatorStats === null) {
    const departments = getDepartments(state);
    const user = getCurrentUser(state);
    return parseRemediationStatsData(null, user, departments);
  }
  return remediatorStats;
};

export const getRemediatorStatsLoading = (state) => {
  const _state = getStatsState(state);
  return _state?.remediatorStatsLoading ?? false;
};

export const getCurrentDateRange = (state) => {
  const _state = getStatsState(state);
  return _state?.currentDateRange;
};

export const getCurrentOrgLogo = (state) => {
  const _state = getStatsState(state);
  return _state?.currentOrgLogo;
};
export const getMitigatorDashboardStatsData = (state) => {
  const _state = getStatsState(state);
  return _state.mitigatorDashboardData;
};
